import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Modals from 'root/modals';
import View from 'view/base';
import View_Emoji from 'view/emoji';
import View_New_Announcement from 'view/portal/new_announcement';

export default View.extend({
    className: 'portal-announcement-preview',

    embed: '',

    events: {
        'click .reaction-add'             : 'onLike',
        'click .reaction'                 : 'onReactionVote',
        'click .announcement-edit'        : 'onEdit',
        'click .announcement-delete'      : 'onDelete',
        'click .read-more'                : 'onReadMore'
    },

    dom_handlers: {
        onLike: function(e) {
            e.preventDefault();
            e.stopPropagation();

            if (!(this.views.emoji instanceof View_Emoji)) {
                this.views.emoji = new View_Emoji({
                    onSelect: function(emoji) {
                        this.voteReaction(emoji);
                        this.views.emoji.hide();
                    }.bind(this),
                    launcher: this.$el.find('.region-reactions:first')
                });
                this.views.emoji.render().$el.hide().appendTo(this.$el.find('.region-emoji:first'));
                this.views.emoji.load();
            }

            this.views.emoji.toggle();

            if ($(e.currentTarget).hasClass('reaction-add')) {
                this.views.emoji.$el.css({
                    'right': 0,
                    'bottom': 0,
                    'margin-bottom': 48
                });
            } else {
                this.views.emoji.$el.css({
                    'left': '',
                    'margin-bottom': ''
                });
            }
        },

        onReactionVote: function(e) {
            e.stopPropagation();

            var emoji = $(e.currentTarget).find('.emoji').text();
            this.voteReaction(emoji);
        },

        onEdit: function(e) {
            this.views.new_announcement = new View_New_Announcement({
                model: this.model,
            });
            this.views.new_announcement.render().$el.appendTo(this.$el);
            this.views.new_announcement.focus();

            this.views.new_announcement.on('close', () => {
                this.views.new_announcement.remove();
                delete this.views.new_announcement;
            });
        },

        onDelete: function(e) {
            Modals.deleteAnnouncement(this.model.id);
        },

        viewVideoAttachment: function(e) {
            e.preventDefault();

            Modals.previewVideo($(e.currentTarget).attr('href'));
        },

        onReadMore: function(e) {
            var content_raw_data = this.model.get('content');
            var content_html = Util.markdownToHtml(content_raw_data);

            this.$el.find('.announcement-content').html(content_html);
        },
    },

    event_handlers: {},

    initialize: function(options) {
        this.embed = options.embed;

        this.views = {
            emoji: {}
        };

        this.listenTo(this.model, 'change:title', this.render);
        this.listenTo(this.model, 'change:content', this.render);
        this.listenTo(this.model, 'change:category', this.render);
        this.listenTo(this.model, 'change:feature_image', this.render);
        this.listenTo(this.model, 'change:feature_video', this.render);
        this.listenTo(this.model, 'change:publish_time', this.render);
    },

    voteReaction: function(emoji) {
        if (!Cache.real_user_id && !Cache.portal_user && !Cache.guest_user) {
            return;
        }

        Cache.app.request({
            action: 'portal_announcement/reaction',
            data: {
                id: this.model.id,
                emoji: '0x' + emoji.codePointAt(0).toString(16)
            },
            context: this,
            success: function(response) {
                this.model.set('reaction', response.reaction);
                this.renderReactions();
            }
        });
    },

    renderReactions: function() {
        var html = '';
        var reactions = this.model.get('reaction');

        if (reactions) {
            try {
                reactions = JSON.parse(reactions);
            } catch(e) {
            }

            reactions.forEach(function(reaction) {
                html += '<span class="reaction">' +
                            '<span class="emoji">' + String.fromCodePoint(reaction.emoji) + '</span>' +
                            '<span class="count">' + reaction.count + '</span>' +
                        '</span>';
            });
        }

        if (Cache.real_user_id || Cache.portal_user || Cache.guest_user) {
            html += '<button type="button" class="reaction-add"></button>';
        }

        this.$el.find('.region-reactions:first').html(html);
    },

    truncateAndFixHTML: function(html, position, ellipsis_html = '') {
        // Get the part of the HTML before the truncation point
        var before_truncate = html.slice(0, position);
        var tag_stack = [];
        // Regex to match all HTML tags (start or end tags)
        var tag_regex = /<\/?([a-zA-Z0-9]+)(\s[^>]*)?>/g;
        var match;
        // Loop through all tags found before the truncate point
        while ((match = tag_regex.exec(before_truncate)) !== null) {
            var [tag, tag_name] = match;
            if (tag.startsWith('</')) {
                // If it's an end tag, try to remove the matching start tag from the stack
                var last_index = tag_stack.lastIndexOf(tag_name);
                if (last_index !== -1) tag_stack.splice(last_index, 1);
            } else if (!tag.endsWith('/>')) {
                // If it's a non-self-closing start tag, push it onto the stack
                tag_stack.push(tag_name);
            }
        }
        // Insert ellipsis + read more link at the truncation point
        var fixed_html = before_truncate + ellipsis_html;
        // Close all unclosed tags
        for (var i = tag_stack.length - 1; i >= 0; i--) {
            fixed_html += `</${tag_stack[i]}>`;
        }

        return fixed_html;
    },

    renderMsg: function(content_html) {
        var content = '<div>';

        var char_limit = this.embed ? 200 : 600;
        var do_ellipsis = content_html.length > char_limit;

        if (do_ellipsis) {
            var truncate_position = char_limit;

            // Find the position of the last complete word
            var last_space = content_html.lastIndexOf(' ', char_limit);
            truncate_position = last_space !== -1 ? last_space : char_limit;

            // Prevent link truncation from being incomplete
            var link_start = content_html.lastIndexOf('<a href', truncate_position);
            if (link_start !== -1) {
                var link_end = content_html.indexOf('</a>', link_start);
                if (link_end !== -1 && link_end > truncate_position) {
                    var after_link = content_html.slice(link_end + 4);
                    var next_word_match = after_link.match(/\s*\S+\s*/);
                    truncate_position = link_end + 4 + (next_word_match ? next_word_match.index + next_word_match[0].length : 0);
                }
            }

            // Define ellipsis + read more HTML
            var ellipsis_html = ' <span class="read-more-dot" style="white-space:nowrap;">... <a href="#" class="read-more primary font-weight-medium">Read more</a></span>';

            // Truncate and insert the read more link, then fix unclosed tags
            content_html = this.truncateAndFixHTML(content_html, truncate_position, ellipsis_html);
        }

        content += content_html + '</div>';

        return content;
    },

    render: function() {
        var content = '';
        var content_html = '';

        var content_raw_data = this.model.get('content');

        content_html = Util.markdownToHtml(content_raw_data);

        content_html = this.renderMsg(content_html);

        var categories = '';

        if (this.model.get('category')) {
            this.model.get('category').split(',').forEach(function(category_name) {
                categories += '<div class="announcement-category-value badge-round badge-primary-invert">' + category_name + '</div>';
            });
        }

        var is_internal_user = Cache.real_user_id && (Cache.app.isAdmin() || Cache.app.isCollaborator());

        var created_user = Cache.user.get(this.model.get('created_by'));

        content +=
            '<div class="announcement-main">' +
                '<div class="announcement-title">' + this.model.get('title') + '</div>' +
                '<div class="created-by">' +
                (created_user ? 'Created by ' + created_user.escape('name') + ', ' : '') +
                Util.moment(this.model.get('publish_time'), 'DD MMM YYYY', false, false) +
                (this.model.isScheduled() ? '<span class="badge-warning-invert margin-left-8">Scheduled</span>' : '') +
                '</div>' +

                '<div class="announcement-category">' + (categories ? categories : '') + '</div>' +

                (this.model.get('feature_image') ? '<div class="announcement-feature-img"><img src="' + this.model.get('feature_image') + '" /></div>' : '') +
                (this.model.get('feature_video') ? '<div class="announcement-feature-img"><video preload="metadata" src="' + this.model.escape('feature_video') + '" controls muted></video></div>' : '') +
                '<div class="announcement-content tiptap-content">' + content_html + '</div>' +
                '<div class="announcement-actions">' +
                    '<div class="announcement-reaction">' +
                        '<div class="region-reactions"></div>' +
                        '<div class="region-emoji"></div>' +
                    '</div>' +
                '</div>' +
            '</div>' +
            (is_internal_user && !this.embed ?
            '<div class="announcement-buttons">' +
                '<div class="button-dropdown">' +
                    '<button type="button">' +
                        '<i class="fal fa-ellipsis-h"></i>' +
                    '</button>' +
                    '<div style="display: none;">' +
                       '<ul class="dropdown">' +
                            '<li class="announcement-button announcement-edit"><button type="button" class="admin-edit">Edit</button></li>' +
                            '<li class="announcement-button announcement-delete"><button type="button" class="admin-delete">Delete</button></li>' +
                        '</ul>' +
                    '</div>' +
                '</div>' +
             '</div>' : '');

        this.$el.html(content);

        this.renderReactions();

        return this;
    }
});